import { fetchPublicRuntimeTheme as fetchPublicRuntimeThemeFromApiBase } from '@emporion/ui'
import { API_BASE } from '../constants'
import type { RuntimeTheme } from './types'

export const fetchPublicRuntimeTheme = (): Promise<RuntimeTheme> =>
  fetchPublicRuntimeThemeFromApiBase(API_BASE)
